import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Services from './views/Services.vue'
import Artists from './views/Artists.vue'
import Rates from './views/Rates.vue'
import Contact from './views/Contact.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'studio',
      component: Home
    },
    {
      path: '/services',
      name: 'services',
      component: Services
    },
    {
      path: '/artists',
      name: 'artists',
      component: Artists
    },
    {
      path: '/rates',
      name: 'rates',
      component: Rates
    },
    { 
      path: '/contact',
      name: 'contact',
      component: Contact
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
